import { Box, Container, SimpleGrid, Text, Flex, Image } from "@chakra-ui/react";
import { Link as RouterLink } from "react-router-dom";
import type { Category } from "../types";

const CategoryIconGrid = ({ categories }: { categories: Category[] }) => {
  if (categories.length === 0) return null;

  return (
    <Box as="section" py={12} bg="rs.bgAlt">
      <Container maxW="container.xl" px={{ base: 4, md: 6 }}>
        <SimpleGrid columns={{ base: 2, sm: 3, md: 4, lg: 6 }} spacing={4}>
          {categories.map((category) => (
            <Flex
              key={category.id}
              as={RouterLink}
              to={`/category/${category.slug}`}
              direction="column"
              align="center"
              justify="center"
              gap={3}
              p={5}
              bg="rs.surface"
              border="1px solid"
              borderColor="rs.border"
              borderRadius="10px"
              transition="all 0.15s"
              _hover={{ borderColor: "rs.redBorder", bg: "rs.surfaceHover" }}
            >
              <Flex
                w="52px"
                h="52px"
                borderRadius="10px"
                bg="rs.redAlpha"
                border="1px solid"
                borderColor="rs.redBorder"
                align="center"
                justify="center"
                overflow="hidden"
              >
                {category.iconUrl ? (
                  <Image
                    src={category.iconUrl}
                    alt={category.name}
                    boxSize="30px"
                    objectFit="contain"
                  />
                ) : (
                  <Text fontSize="20px" color="rs.red">
                    {category.name.charAt(0)}
                  </Text>
                )}
              </Flex>
              <Text
                fontSize="12.5px"
                fontWeight="500"
                color="rs.text"
                textAlign="center"
              >
                {category.name}
              </Text>
            </Flex>
          ))}
        </SimpleGrid>
      </Container>
    </Box>
  );
};

export default CategoryIconGrid;
